import { render, staticRenderFns } from "./SchoolsTable.vue?vue&type=template&id=98143a20&"
import script from "./SchoolsTable.vue?vue&type=script&lang=js&"
export * from "./SchoolsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports